export const EXSBINVOICETYPE_CREATE_RESET = 'EXSBINVOICETYPE_CREATE_RESET'
export const EXSBINVOICETYPE_CREATE_SET_CREATED = 'EXSBINVOICETYPE_CREATE_SET_CREATED'
export const EXSBINVOICETYPE_CREATE_SET_ERROR = 'EXSBINVOICETYPE_CREATE_SET_ERROR'
export const EXSBINVOICETYPE_CREATE_SET_VIOLATIONS = 'EXSBINVOICETYPE_CREATE_SET_VIOLATIONS'
export const EXSBINVOICETYPE_CREATE_TOGGLE_LOADING = 'EXSBINVOICETYPE_CREATE_TOGGLE_LOADING'
